<!-- 成绩 -->
<template>
    <div>
      <div class="course_scoreInfo">
        <el-row>
          <el-input v-model="searchInfo.studentOrName" placeholder="请输入学号或姓名" style="width: 200px;" prefix-icon="el-icon-search" ></el-input>
          <label style="margin-left: 20px;">班级：</label>
          <el-select clearable v-model="searchInfo.classId" filterable placeholder="请选择班级">
            <template v-for="(item ,index) in classList">
              <el-option :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
            </template>
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="getInfo(page = 1)">搜索</el-button>
          <el-button type="success" icon="el-icon-view" @click="lookScoreWeight">查看成绩权限</el-button>
        </el-row>
        <el-row class="content_block mt20">
          <el-row>
            <el-table
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
              <el-table-column prop="studentSn" header-align="center" align="center" label="学号"> </el-table-column>
              <el-table-column prop="studentName" header-align="center" align="center" label="姓名"> </el-table-column>
              <el-table-column prop="className" header-align="center" align="center" label="班级"> </el-table-column>
              <!-- 以下三列为延安大学交付新增（B3）：onlineTime30/activeDays/lastLoginTime，字段缺省显示 "-" -->
              <el-table-column header-align="center" align="center" label="近30天在线时长" min-width="130">
                <template slot-scope="scope">
                  {{pickField(scope.row, ["onlineTime30", "onlineDuration30", "onlineTime", "onlineDuration"], "-")}}
                </template>
              </el-table-column>
              <el-table-column header-align="center" align="center" label="活跃天数" min-width="100">
                <template slot-scope="scope">
                  {{pickField(scope.row, ["activeDays", "activeDayCount", "loginDays"], "-")}}
                </template>
              </el-table-column>
              <el-table-column header-align="center" align="center" label="最近登录时间" min-width="150">
                <template slot-scope="scope">
                  {{pickField(scope.row, ["lastLoginTime", "lastLoginDate", "lastLogin", "lastOnlineTime"], "-")}}
                </template>
              </el-table-column>
              <el-table-column prop="signinScore" header-align="center" align="center" label="签到成绩"> </el-table-column>
              <el-table-column prop="courseScore" header-align="center" align="center" label="章节练习成绩"> </el-table-column>
              <el-table-column prop="realOperationScore" header-align="center" align="center" label="课程实操成绩"> </el-table-column>
              <el-table-column prop="questionHomeworkScore" header-align="center" align="center" label="作业成绩"> </el-table-column>
              <el-table-column prop="examScore" header-align="center" align="center" label="考试成绩"> </el-table-column>
              <el-table-column prop="chatScore" header-align="center" align="center" label="互动成绩"> </el-table-column>
              <el-table-column prop="totalScore" header-align="center" align="center" label="总成绩"> </el-table-column>
              <el-table-column prop="manualScore" header-align="center" align="center" label="手动调整"> </el-table-column>
              <el-table-column prop="lastScore" header-align="center" align="center" label="最终成绩"> </el-table-column>
              <el-table-column prop="lastStatus" header-align="center" align="center" label="成绩状态">
                <!-- <template slot-scope="scope">
                  <span :class="scope.row.type == 1?'mainWeak':scope.row.type == 2?'primary':'red'">
                    {{scope.row.type == 1?"优秀":scope.row.type == 2?"一般":"差"}}
                  </span>
                </template> -->
              </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[8, 20, 50, 100]"
                :page-size="limit"
                background
                :hide-on-single-page="true"
                layout="sizes, prev, pager, next,jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-row>
        </el-row>
      </div>
    </div>
</template>
<script>
import {getClassInfo} from "@/common/getInfo";	//加载数据
export default {
  name: 'ScoreInfo',
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      options: [],
      value: '',
      searchInfo:{
        classId:"",
        studentOrName:""
      },
      tableData:[],

      total: 0,
      limit:8,
      page:1,
      classList:[]
    }
  },
  created() {
    this.getInfo();
    this.getClassList();
  },
  methods: {
    pickField(obj, keys, def) { //按优先级取第一个有值的字段（B3 新增列：字段缺省时显示兜底值）
      if (!obj) return def;
      for (let i = 0; i < keys.length; i++) {
        let v = obj[keys[i]];
        if (v !== undefined && v !== null && v !== "") return v;
      }
      return def;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取数据
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.courseId,
      }
      param = Object.assign(param,this.searchInfo);
      this.$post("/api/teacherOpenCourseScoreDashboard/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getClassList(){ //获取班级信息
      getClassInfo({teacherOpenCourseId:this.courseId}).then(ret =>{ //根据课程ID获取班级信息
        if(ret.code == 0){
          this.classList = ret.data;
        }
      });
    },
    lookScoreWeight(){ //查看成绩权限
      this.$router.push({name:'ScoreWeight',query:{courseId:this.courseId}});
    }
  }
};
</script>
<style  lang="less">
  .course_scoreInfo{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .title_img{
        width: 20px;
      }
      .class_img{
        float: left;margin-right: 10px;
      }
      .echarts_row{
        padding: 20px;
      }
      .block_time{
        display: initial;
        margin-left: 20px;
      }
      .el-calendar__body{
        th{
          border-top: 1px solid #E5E5E5;
          border-left: 1px solid #E5E5E5;
          background-color: #EFF2F7;
        }
        th:last-child{
          border-right: 1px solid #E5E5E5;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/course/components/ScoreInfo.vue